import { useCallback, useRef, useState } from 'react';

import {
  AppliedFilter,
  FilterArrayItem,
  ShipmentFiltersPayload,
} from '../Shipments/ControlTower/types';

export function useAiHistoryFiltersController() {
  const [appliedFilters, setAppliedFilters] = useState<AppliedFilter[]>([]);
  const [filterArray, setFilterArray] = useState<FilterArrayItem[]>([]);
  const [isSearchVisible, setIsSearchVisible] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>('');

  const filtersPayloadRef = useRef<ShipmentFiltersPayload | null>(null);

  const setFiltersPayload = useCallback(
    (payload: ShipmentFiltersPayload | null) => {
      filtersPayloadRef.current = payload;
    },
    []
  );

  return {
    appliedFilters,
    setAppliedFilters,
    filterArray,
    setFilterArray,
    isSearchVisible,
    setIsSearchVisible,
    searchQuery,
    setSearchQuery,
    filtersPayloadRef,
    setFiltersPayload,
  };
}
